import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import RoomIcon from "@mui/icons-material/Room";
import { toPrice } from "../../../utils/toPrice";
import { emptys } from "../../../data/main";

export default function writeListTable({
  columns,
  title = "",
  data = [],
  type,
  warehouse = 0,
}: {
  columns: Array<object>;
  title?: string;
  data?: stdObject;
  type: string;
  warehouse?: string | number;
}) {
  const getValue = (e: stdObject) => {
    if (type === "TAR") {
      return typeof data[e.CODTAR] === "number"
        ? toPrice(data[e.CODTAR])
        : data[e.CODTAR];
    } else {
      return data[e.CODALM]
        ? data[e.CODALM].DISSTO === data[e.CODALM].ACTSTO
          ? data[e.CODALM].ACTSTO
          : data[e.CODALM].DISSTO + " / " + data[e.CODALM].ACTSTO
        : "";
    }
  };

  const getValidColor = (e: stdObject) =>
    (type === "TAR" && data[e.CODTAR] <= 0) ||
    (type === "ALM" && (data[e.CODALM].ACTSTO < 0 || data[e.CODALM].DISSTO < 0))
      ? colors.red
      : colors.black;

  const getBold = (e: stdObject) =>
    type === "ALM" && e.CODALM === Number(warehouse) ? "bolder" : 100;

  const columnsFiltered =
    type !== "DOM"
      ? columns.filter((e: stdObject) => data[e[`COD${type}`]])
      : columns;

  return (
    <table>
      <tbody>
        {type === "DOM"
          ? columnsFiltered.map((e: any, index: number) => (
              <tr key={index}>
                <td valign="top">
                  {e.GPS.length === 2 && (
                    <RoomIcon style={{ color: colors.red, fontSize: 20 }} />
                  )}
                </td>
                <td>{e.DOM}</td>
              </tr>
            ))
          : columnsFiltered.map((e: stdObject, index: number) => (
              <tr
                key={index}
                style={{ color: getValidColor(e), fontWeight: getBold(e) }}
              >
                {columnsFiltered.length > 1 && (
                  <td style={{ whiteSpace: "nowrap" }}>{e[title]}:</td>
                )}
                <td align="right">{getValue(e)}</td>
                {type === "ALM" &&
                  !emptys.includes(data[e.CODALM]?.RMASTO) &&
                  data[e.CODALM].RMASTO !== 0 && (
                    <td align="right">
                      RMA: {data[e.CODALM].RMASTO.toString()}
                    </td>
                  )}
              </tr>
            ))}
      </tbody>
    </table>
  );
}
